import { Directive, HostListener, ElementRef, Input } from '@angular/core';

import * as Clipboard from '../../../../node_modules/clipboard/dist/clipboard.min.js';
import * as $ from 'jquery';
import { AlertService } from "../../../providers/alert.service";

//复制指令
//TQQ 2017-05-09
@Directive({
    selector: '[copy]'
})
export class CopyDirective {
    @Input('copy') cliptext: any;
    constructor(
        private alert: AlertService,
        private el: ElementRef
    ) {
        let clipboard = new Clipboard(el.nativeElement, {
            text: s => {
                return this.cliptext;
            }
        });
        clipboard.on('success', e => {
            this.alert.okAlert('复制成功');
            e.clearSelection();
        });
        clipboard.on('error', function (e) {
            console.error('Action:', e.action);
            console.error('Trigger:', e.trigger);
        });
    }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/shared/copy/copy.directive.ts